import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

/**
 * Employee (ESS) wallet endpoints served by corebackend (`Employee/Wallet`).
 *
 * Not to be confused with:
 *   - walletService      — the wallet backend itself (vaspay, api_key auth)
 *   - adminWalletService — the company wallet endpoints (`Admin/Wallet`)
 *
 * These used to be called through the legacy middleware; the payouts now live
 * in corebackend, which signs the wallet request server-side, so no `api_key`
 * header is sent from the client.
 */
const service = createService(SERVICE_INSTANCES.employeeWallet)

export const EMPLOYEE_WALLET_INSTANCE = service.instanceKey

export const EMPLOYEE_WALLET_ENDPOINTS = {
  GET_BANK_TRANSFER_DETAILS: "/employee/wallet/getbanktransferdetails",
  INITIATE_WALLET_TRANSFER: "/employee/wallet/initiate_wallet_transfer",
  INITIATE_BANK_TRANSFER: "/employee/wallet/initiate_bank_transfer",
} as const

/** `Response<PortalResponseModel>` — the legacy `{status, msg}` sits in `data`. */
export interface IEmployeeWalletTransferRes
  extends IBaseRes<{ status?: string; msg?: string; data?: any }> {}

export const employeeWalletService = {
  instanceKey: service.instanceKey,

  getBankTransferDetails: (body: Record<string, any>[]) =>
    service.post<IEmployeeWalletTransferRes>(
      EMPLOYEE_WALLET_ENDPOINTS.GET_BANK_TRANSFER_DETAILS,
      body
    ),

  initiateWalletTransfer: (body: Record<string, any>) =>
    service.post<IEmployeeWalletTransferRes>(
      EMPLOYEE_WALLET_ENDPOINTS.INITIATE_WALLET_TRANSFER,
      body
    ),

  initiateBankTransfer: (body: Record<string, any>) =>
    service.post<IEmployeeWalletTransferRes>(
      EMPLOYEE_WALLET_ENDPOINTS.INITIATE_BANK_TRANSFER,
      body
    ),
}
